export const SEARCH_INDEX_IDS = {
  COURSE: 'search-courses',
  EXECUTIVE_EDUCATION: 'search-executive-education',
  PATHWAYS: 'search-pathways',
  PROGRAMS: 'search-programs',
  VIDEOS: 'search-videos',
};
